import { render, staticRenderFns } from "./zfbIndex.vue?vue&type=template&id=1e9bdd10&scoped=true"
import script from "./zfbIndex.vue?vue&type=script&lang=js"
export * from "./zfbIndex.vue?vue&type=script&lang=js"
import style0 from "./zfbIndex.vue?vue&type=style&index=0&id=1e9bdd10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9bdd10",
  null
  
)

export default component.exports